import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Kbd({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-[4px] border border-hairline-strong border-b-2 bg-surface px-1 font-sans text-[0.6875rem] font-semibold text-ink-muted',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
